import { Payment } from '@spike/payments-model';
import { FunctionComponent } from 'react';
import Transaction from './Transaction';

interface TransactionProps {
    payment: Payment;
    onViewPayment: (payment: Payment) => void;
}

const excludeChannels = ['other', 'cash', 'credit_card'];

export const PaymentTransaction: FunctionComponent<TransactionProps> = props => (
    <Transaction
        paymentMethodId={props.payment.paymentMethod.id || ''}
        paymentMethodName={props.payment.paymentMethod.name || ''}
        cardDigits={props.payment.paymentMethod.cardDigits || ''}
        amount={props.payment.amount}
        date={props.payment.paidAt}
        channel={
            excludeChannels.includes(props.payment?.paymentType?.id) ? undefined : props.payment?.paymentType?.name
        }
        type="Booking Payments"
        onViewPayment={() => props.onViewPayment(props.payment)}
    />
);

export default PaymentTransaction;
